import { CustomEvent } from "@spscommerce/utils";

import { ModalActionMethod } from "../decorators/modal-action";

export interface ModalEventInit extends EventInit {
    action?: ModalActionMethod;
}

export class ModalEvent extends CustomEvent {
    action: ModalActionMethod;

    constructor(eventName: string, initDict: ModalEventInit = {}) {
        super(eventName, initDict);
        this.action = initDict.action;
    }
}
